<template>
  <v-dialog v-model="mostrado" persistent scrollable max-width="800px">
    <v-form @submit.prevent="guardar">
      <v-card>
        <v-card-title class="pt-2 pb-0">{{ tituloModal }}</v-card-title>

        <v-divider class="my-2"></v-divider>

        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="12" lg="7">
              <v-row dense>
                <v-col cols="12" lg="8">
                  <v-text-field
                    v-model="form.fecha"
                    ref="fecha"
                    type="datetime-local"
                    label="Fecha de Pago"
                    :max="new Date().toISOString().split('T')[0] + 'T23:59'"
                    outlined
                    dense
                    hide-details
                    clearable
                    required></v-text-field>

                  <small v-for="error in errores.fecha" :key="error" class="d-block text-danger">
                    {{ error }}
                  </small>
                </v-col>

                <v-col cols="12" lg="4">
                  <span class="h5 d-block">
                    <strong>Saldo: </strong>
                    {{
                      Number(
                        (
                          detalleSoliicitud?.importe -
                          pagosDetallesSolicitudes.reduce((acc, pago) => acc + Number(pago.monto), 0)
                        ).toFixed(2),
                      ).toFixed(2)
                    }}
                  </span>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="form.monto"
                    type="number"
                    label="Monto"
                    min="1"
                    step="0.01"
                    outlined
                    dense
                    hide-details
                    clearable></v-text-field>

                  <small v-for="error in errores.monto" :key="error" class="d-block text-danger">
                    {{ error }}
                  </small>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="form.numero_comprobante"
                    type="text"
                    label="Número de Comprobante"
                    outlined
                    dense
                    hide-details
                    clearable></v-text-field>

                  <small v-for="error in errores.numero_comprobante" :key="error" class="d-block text-danger">
                    {{ error }}
                  </small>
                </v-col>

                <v-col cols="12">
                  <v-file-input
                    v-model="archivo"
                    class="file-input"
                    label="Adjuntar Comprobante de Pago JPG, PNG, PDF"
                    accept="image/jpeg, image/png, image/jpg, application/pdf"
                    :prepend-icon="''"
                    prepend-inner-icon="mdi-paperclip"
                    outlined
                    dense
                    clearable
                    hide-details
                    @change="onFileChange"></v-file-input>

                  <small class="d-block text-muted"> Formatos permitidos: JPG, PNG, PDF </small>

                  <small v-for="error in errores.archivo_comprobante" :key="error" class="d-block text-danger">
                    {{ error }}
                  </small>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" lg="5">
              <div class="d-flex justify-center align-center contenedor-previsualizacion">
                <v-img v-if="previsualizacion && esImagen" :src="previsualizacion" contain height="300%" />

                <iframe v-else-if="previsualizacion && esPDF" :src="previsualizacion" height="300px"></iframe>

                <v-icon v-else>mdi-image-broken-variant</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-2"></v-divider>

        <v-card-actions>
          <v-btn color="blue darken-1" type="button" :disabled="guardando" text @click.prevent="cerrar"> Cerrar </v-btn>
          <v-btn color="blue darken-1" type="submit" :disabled="guardando" :loading="guardando" text> Guardar </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import pagosDetallesSolicitudesService from '../services/pago-detalle-solicitud';

export default {
  name: 'ModalFormRegistrarPagoDetalleSolicitud',
  computed: {
    tituloModal() {
      return this.form?.id ? 'EDITAR PAGO DE DETALLE DE SOLICITUD' : 'REGISTRAR PAGO DE DETALLE DE SOLICITUD';
    },
  },
  watch: {
    'form.fecha': function () {
      this.errores.fecha = [];
    },
    'form.monto': function () {
      this.errores.monto = [];
    },
    'form.numero_comprobante': function () {
      this.errores.numero_comprobante = [];
    },
    'form.archivo_comprobante': function () {
      this.errores.archivo_comprobante = [];
    },
  },
  data() {
    return {
      mostrado: false,
      detalleSoliicitud: null,
      pagosDetallesSolicitudes: [],
      archivo: null,
      previsualizacion: null,
      esImagen: false,
      esPDF: false,
      form: {
        detalle_solicitud_id: null,
        fecha: null,
        monto: null,
        numero_comprobante: null,
        archivo_comprobante: null,
        registrado_por_id: this.$store.state.DATA_USER.id,
        registrado_por: `${this.$store.state.DATA_USER.nombres} ${this.$store.state.DATA_USER.pri_apellido} ${this.$store.state.DATA_USER.seg_apellido}`,
      },
      errores: {
        monto: [],
        fecha: [],
        numero_comprobante: [],
        archivo_comprobante: [],
      },
      guardando: false,
    };
  },
  methods: {
    abrir(detalleSolicitudId, datosDetalleSolicitud, datosPagosDetalles) {
      this.form.detalle_solicitud_id = detalleSolicitudId;
      this.form.fecha = null;
      this.form.monto = null;
      this.form.numero_comprobante = null;
      this.form.archivo_comprobante = null;
      this.form.registrado_por_id = this.$store.state.DATA_USER.id;
      this.form.registrado_por = `${this.$store.state.DATA_USER.nombres} ${this.$store.state.DATA_USER.pri_apellido} ${this.$store.state.DATA_USER.seg_apellido}`;

      this.detalleSoliicitud = datosDetalleSolicitud;
      this.pagosDetallesSolicitudes = datosPagosDetalles;

      this.errores.fecha = [];
      this.errores.monto = [];
      this.errores.numero_comprobante = [];
      this.errores.archivo_comprobante = [];

      this.archivo = null;
      this.previsualizacion = null;
      this.esImagen = false;

      this.mostrado = true;
    },
    cerrar() {
      this.mostrado = false;
    },
    onFileChange() {
      if (this.archivo) {
        const reader = new FileReader();
        const fileType = this.archivo.type;

        reader.onload = (e) => {
          const result = e.target.result;

          this.form.archivo_comprobante = result.split(',')[1];

          if (fileType.includes('image')) {
            this.previsualizacion = result;
            this.esImagen = true;
            this.esPDF = false;
          } else if (fileType.includes('pdf')) {
            const blob = new Blob([this.archivo], { type: fileType });
            const url = URL.createObjectURL(blob);

            this.previsualizacion = url;
            this.esImagen = false;
            this.esPDF = true;
          } else {
            this.previsualizacion = null;
            this.esImagen = false;
            this.esPDF = false;
          }
        };

        reader.readAsDataURL(this.archivo);
      } else {
        this.previsualizacion = null;
        this.esImagen = false;
        this.esPDF = false;
        this.form.archivo_comprobante = null;
      }
    },
    async guardar() {
      this.guardando = true;

      try {
        const response = await pagosDetallesSolicitudesService.create(this.form);
        const data = response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: mensaje || 'Pago del detalle de la solicitud guardado correctamente',
          type: 'success',
        });
        this.cerrar();
        this.$emit('actualizar', data.datos);
      } catch (error) {
        window.console.error({ error });
        const data = error?.response?.data;
        const mensaje = data?.mensaje;
        const errores = data?.errores;

        if (errores) {
          this.errores = errores;
        }

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al guardar el pago del detalle de la solicitud',
          type: 'error',
        });
      }

      this.guardando = false;
    },
  },
};
</script>

<style scoped>
.contenedor-previsualizacion {
  border: 1px solid #c5c5c5;
  border-radius: 5px;
  padding: 10px;
  height: 320px;
  max-height: 320px;
  background-color: #f5f5f5;
}

.contenedor-previsualizacion iframe {
  border: none;
}
</style>